import { createFileRoute } from "@tanstack/react-router";
import { OperatorPackagesPage } from "@/features/operator/PackagesPage";

export const Route = createFileRoute("/app/operator/packages")({ component: OperatorPackagesPage });
